export const getLoginTabs = (invitationCode?: string): string[] => {
    return invitationCode ? ["Login"] : ["Login", "Login with SSO"];
};
